import { render } from "react-dom";
import App from './App';

import './styles/reset.css';
import './styles/style.css';

render(<App />, document.querySelector('.root'));